// Brand Component
const brandComponent = document.querySelector('.brands-navigation');
if (brandComponent) {
    brandComponent.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        let target = this.getAttribute('href');
        navUtils.scrollTo(target);
      });
    });
}
